export const IMAGES = {
  heroTeaGarden:
    "https://static.prod-images.emergentagent.com/jobs/7aef43e7-0047-434d-a303-3b703e9bcdde/images/591cc6284fad7e532911034cdde5a7fd8e2b0a101302fa144f99a8a73500723d.png",
  jaflong:
    "https://static.prod-images.emergentagent.com/jobs/7aef43e7-0047-434d-a303-3b703e9bcdde/images/549663f4b0457e2b72bdc1124df8a5147fd33a4b7d2eb243cb7ffdaed18f3278.png",
  bisanakandi:
    "https://static.prod-images.emergentagent.com/jobs/7aef43e7-0047-434d-a303-3b703e9bcdde/images/aa19733a644cb75994e1e181e4563ce5b712cfaf5b8012a37c110d4876eb6cca.png",
  ratargul:
    "https://static.prod-images.emergentagent.com/jobs/7aef43e7-0047-434d-a303-3b703e9bcdde/images/7522031b603b17544f48298af0bc518cc3b023b93588458a45a8584b42ee8a64.png",
  haor:
    "https://static.prod-images.emergentagent.com/jobs/7aef43e7-0047-434d-a303-3b703e9bcdde/images/be926f1610e356e8bd9dc36c0d9afa07c5ab3693fb5bfbd9b05ff56c6d7e36fe.png",
  flagMotif:
    "https://static.prod-images.emergentagent.com/jobs/7aef43e7-0047-434d-a303-3b703e9bcdde/images/fefc5465de513330f4fe8c83b4cd29a79bc6968cfc570d4959934eef7a199022.png",
};

export const DISTRICTS = ["Sylhet", "Moulvibazar", "Habiganj", "Sunamganj"];
export const PLATFORMS = ["YouTube", "Facebook", "Instagram", "TikTok", "Other"];

export const PLATFORM_COLORS = {
  YouTube: "#FF0000",
  Facebook: "#1877F2",
  Instagram: "#E1306C",
  TikTok: "#000000",
  Other: "#006A4E",
};

// Authentic Bangladeshi / Sylheti people & scenes (no culturally-wrong imagery).
export const CAMPAIGN = {
  creators: [
    // tea garden worker (Bangladesh) — iconic Sylhet, eager-loaded hero frame
    "https://images.pexels.com/photos/36720891/pexels-photo-36720891.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=600",
    // street-food vendor in lungi (authentic Bangladeshi)
    "https://images.unsplash.com/photo-1771699435180-1aa08bf9a246?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
    // rural market vendor carrying baskets (authentic Bangladeshi)
    "https://images.unsplash.com/photo-1607710577593-5c806a0dc7b9?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
    // Jaflong riverbank with boatman (Sylhet)
    "https://images.pexels.com/photos/29898061/pexels-photo-29898061.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=600",
    // Dhaka street-food stall (authentic Bangladeshi)
    "https://images.pexels.com/photos/34883740/pexels-photo-34883740.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=600",
  ],
  // Real product photography (client to supply exact prize models/units).
  prizeBike: "https://images.unsplash.com/photo-1609142297296-101b9dfc9418?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", // standard street motorbike (not a superbike)
  prizePhone: "https://images.pexels.com/photos/29020349/pexels-photo-29020349.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900", // real iPhone
  prizeDrone: "https://images.pexels.com/photos/8441676/pexels-photo-8441676.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900", // real camera drone
  prizeAndroid: "https://images.unsplash.com/photo-1610945265064-0e34e5519bbf?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", // real Android flagship (no on-device text)
  prizeAndroid2: "https://images.unsplash.com/photo-1707438095940-1eee18e85400?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", // real Android flagships (distinct shot for 5th prize)
};
